interface ApiResponse {
  content: string;
}

const baseApiUrl = process.env.REACT_APP_API_URL ?? "";

export const generateTechnicalMetadataFromFiles = async (
  files: File[],
  variables: boolean,
): Promise<ApiResponse> => {
  try {
    const params = new URLSearchParams({ variables: variables.toString() });
    const fullUrl = `${baseApiUrl}/api/annotate/technical/files?${params.toString()}`;

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("modules", file);
    });

    const res = await fetch(fullUrl, {
      method: "POST",
      body: formData,
    });

    if (!res.ok) throw new Error(`Error: ${res.statusText}`);
    return await res.json();
  } catch (error) {
    console.error("Error generating from files:", error);
    throw error;
  }
};

export const generateTechnicalMetadataFromRepo = async (
  repoUrl: string,
  variables: boolean,
): Promise<ApiResponse> => {
  try {
    const params = new URLSearchParams({
      variables: variables.toString(),
      repo_url: repoUrl,
    });
    const fullUrl = `${baseApiUrl}/api/annotate/technical/repo?${params.toString()}`;

    const res = await fetch(fullUrl, {
      method: "POST",
    });

    if (!res.ok) throw new Error(`Error: ${res.statusText}`);
    return await res.json();
  } catch (error) {
    console.error("Error generating from repo:", error);
    throw error;
  }
};
